import React, { useEffect } from 'react'
import Header from "../../../components/User/Header/Header"
import Footer from "../../../components/User/Footer/Footer"
import HomeBanner from "../../../images/background/homeBanner.jpg"
import "../../../css/header.css";
import "../../../css/bootstrap.css";
import "../../../css/element.css";
import "../../../css/flaticon.css";
import "../../../css/font-awesome.css";
import "../../../css/global.css";
import "../../../css/responsive.css";
import "../../../css/style.css";

function AboutUs() {

   useEffect(()=>{
  window.scrollTo(0,0)
    },[])

  return (
    <div className='page-wrapper'>
     <Header/>

      {/* Hero Section  */}
      <section
          class="call-to-action-one sp-four"
          style={{ backgroundImage: `url(${HomeBanner})` }}
        >
          <div class="container">
            <div class="sec-title-one white text-center">
              {/* <h5>Keep Runing</h5> */}
              <h2>About Us</h2>
            </div>
            {/* <div class="text mt-20 mb-50">
              Excepteur sint occaecat cupidatat non proident, sunt in culpa qui
              officia deserunt mollit anim id est <br /> laborum.sed ut
              perspiciatis unde.
            </div>
            <div class="link-btn">
              <a href="#" class="theme-btn btn-style-two">
                Get Appointment
              </a>
            </div> */}
          </div>
        </section>

     {/* Our Philosophy  */}
     <section style={{padding:"54px 0px 0px"}} className="about-section-new grey-bg sp-two">
          <div className="container">
            <div className="sec-title-one centered">
              {/* <h5>Our Qualification</h5> */}
              <h2>
                <span>Our</span> Philosophy
              </h2>
              <div className="text mb-2">
               <p>
               Besides a comforting journey and great food there's always something that every traveler wants- no unnecessary lugging of baggage.
Carrymybaggage.com is a baggage transfer service that provides door-to- door, door-to-airport, and airport-to- door collection and delivery for all kinds of baggage items.
               </p>
              
              </div>
            </div>
          </div>
        </section>

     {/* Our Founders */}
     <section style={{padding:"60px 0px 0px 0px"}} className="testimonial-page sp-seven">
        <div className="container">
            <div className="sec-title-one centered mb-50">
                {/* <h5>Testimonials</h5> */}
                <h2><span>Our</span> Co-Founders</h2>
            </div>
            <div className="row">
            <div className="col-xl-6 col-md-12 col-sm-12 mb-50">
                    <div className="testimonial-item-two testimonial-item-two-new mt-35">
                        <i className="flaticon-left-quote"></i>
                        <p>Faisal Islam being the co- founder of carrymybaggage has played an eminent role in shaping business strategies. He has got extensive experience and knowledge in communication and customer relations. He believes in transparency and constant communication with the clients which sets carrymybaggage a step ahead in providing nothing less than the best. Faisal has a pivotal role in shaping business strategies and consumer policies for the company.</p>
                        <a href="#"><h6>Faisal Islam</h6></a>
                        <span>Co-Founder</span>
                    </div>
                </div>
                <div className="col-xl-6 col-md-12 col-sm-12 mb-50">
                    <div className="testimonial-item-two testimonial-item-two-new mt-35">
                        <i className="flaticon-left-quote"></i>
                        <p>The Founder of the Company, Aamir Islam is a first-generation entrepreneur with immense first-hand experience in export and shipment. With a feverous passion for travelling, he founded CarryMyBaggage.com to provide a seamless experience of transferring luggage to the destination of choice gobally. CarryMyBaggage offers first-of-its-kind luggage solutions company that uses time-trusted shipment methods & practices for domestic and international transfers for personal baggage. 
                        </p>
                        <a href="#"><h6>Aamir Islam</h6></a>
                        <span>Co-Founder</span>
                    </div>
                </div>

               

            </div>
        </div>
    </section>
<button className="scroll-top scroll-to-target" data-target="html">
    <span className="fa fa-arrow-up"></span>
</button>
<Footer/>
    </div>
  )
}

export default AboutUs


